import PropTypes from "prop-types";
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useMaterialUIController } from "context";

function ProtectedRoute({ children }) {
  const [controller] = useMaterialUIController();
  const { user } = controller;
  const location = useLocation();

  if (!user) {
    // Redirect to login page with return url
  return <Navigate to="/authentication/sign-in" state={{ from: location }} replace />;
  }

  return children;
}

export default ProtectedRoute;

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
};
